import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { Slot } from '../../Model/Slot';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';

export class BatchUpdateSlotUseCase {
  constructor(private repo: SlotRepository) {}

  execute(slots: Partial<Slot>[], current: User) {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(current, '수정')) {
      throw new Error(getRestrictionMessage('수정', current));
    }

    const isAdmin = current.grade === 'ADMIN';
    const isLimitedAdmin = isAdmin && Boolean(current.is_limited_partner_admin);
    const canEditDates = isAdmin && !isLimitedAdmin;

    // 상태(status) 필드 제거 (보안상 한 번 더 처리)
    const sanitizedSlots = slots
      .map(({ status, ...rest }) => {
        if (canEditDates) return rest;
        const { start_date, end_date, ...withoutDates } = rest;
        return withoutDates;
      })
      .filter((slot) => {
        const { id, slotId, ...updatable } = slot as any;
        return Object.keys(updatable).length > 0;
      });

    if (sanitizedSlots.length === 0) {
      // 원본에는 수정할 내용이 있었으나, 권한이 없어서 모두 필터링된 경우
      const hadUpdatable = slots.some(slot => {
        const { id, slotId, status, ...rest } = slot as any;
        return Object.keys(rest).length > 0;
      });
      
      if (hadUpdatable && !canEditDates) {
        throw new Error(
          isLimitedAdmin
            ? '제한형 관리자는 시작일·종료일을 변경할 수 없습니다.'
            : '시작일/종료일은 관리자만 수정할 수 있습니다.',
        );
      }
      throw new Error('수정할 내용이 없습니다.');
    }

    return this.repo.batchUpdate(sanitizedSlots);
  }
}
